// extracted by mini-css-extract-plugin
export default {"formElement":"formElement--wgRwd","small":"small--XH1k5","fullWidth":"fullWidth--rZRKr"};